import type { Step } from '..';
import { StepBasePageObject } from '../../patterns/step/testing/step-base.pageobject';

/**
 * Page object for steps
 */
export class StepPageObject extends StepBasePageObject<Step> {

}
